import React from "react";

const StatisticsBox = ({ className, title, desc, count, svg }) => {
  return (
    <div className={className}>
      {svg}

      <span className="mb-2">{title}</span>
      <div className="text-4xl" dir="ltr">
        100+
      </div>
      <span>{desc}</span>
    </div>
  );
};

export default StatisticsBox;
